/**
 * Copyright © Veeam Software Group GmbH.
 */

export const getResellerDocUrl = (): string => RCOP.utils.HelpCenter.getHelpResource(641);
